import React from 'react';
import { Card } from 'react-bootstrap';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { BudgetConsumptionNode } from '../types';
import { BudgetConsumptionNodeRow } from './BudgetConsumptionNodeRow';

type Props = {
  // The direct reports of the review being viewed (the tree root's children).
  nodes: BudgetConsumptionNode[];
  buildDetailUrl: (reviewId: string) => string;
};

// Budget consumption breakdown for a roll-up review: each direct report's
// consumed-vs-available, each expandable to drill into that report's sub-tree.
export const BudgetConsumptionCard: React.FC<Props> = ({
  nodes,
  buildDetailUrl,
}) => {
  const t = useNamespacedTranslation('compensationReviews.budget');

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="d-flex align-items-center mb-3">
          <FlairIcon icon="phosphor-pulse" className="me-2" />
          <h4 className="mb-0">{t('consumptionTitle')}</h4>
        </div>
        <div className="budget-consumption-node-list">
          {nodes.map((node) => (
            <BudgetConsumptionNodeRow
              key={node.reviewId}
              node={node}
              buildDetailUrl={buildDetailUrl}
            />
          ))}
        </div>
        <div className="text-muted small mt-2">{t('monthlyEquivalents')}</div>
      </Card.Body>
    </Card>
  );
};
